import { TextInput, TextInputProps } from '@mantine/core'
import { useDebouncedValue } from '@mantine/hooks'
import React, { useEffect, useRef, useState } from 'react'

type DebouncedTextInputProps = {
  onDebounceChange: (debouncedValue: string) => void
  numbersOnly: boolean
  wait?: number
}

export const DebouncedTextInput = (props: TextInputProps & DebouncedTextInputProps) => {
  const { value, onDebounceChange, numbersOnly, wait = 500 } = props
  const [nonDebounced, setNonDebounced] = useState(value)
  const [debounced] = useDebouncedValue(nonDebounced, wait)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleValidateChange = (val: string) => {
    if (/^\d*$/.test(val) && numbersOnly) {
      setNonDebounced(val)
    } 
    if (!numbersOnly) {
      setNonDebounced(val)
    }
  }

  useEffect(() => {
    if (value !== nonDebounced) onDebounceChange(debounced as string)
    inputRef?.current?.focus()
  }, [debounced])

  return (
    <TextInput
      {...props}
      value={nonDebounced}
      ref={inputRef}
      onChange={e => handleValidateChange(e.target.value)}
    />
  )
}
